export default {
      id: "chevrondown-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#chevrondown",
      toString: function () {
        return this.url;
      }
    }